<template>

    <v-container fluid="" class="pa-0">
      <forms-add-organisation></forms-add-organisation>

      <v-layout v-if="user.formChange" justify-end="" style="min-height:78px;" class="pr-4">
          <v-flex xs6 md4>
              <v-slide-x-transition>
                  <v-btn rounded="" block="" v-if="user.formChange" @click="reset()" color="warning">Reset</v-btn>
              </v-slide-x-transition>
          </v-flex>
          <v-flex xs6 md4 class="pl-3">
              <v-slide-x-transition>
                  <v-btn rounded="" block="" v-if="user.formChange" @click="store()" color="success">Opslaan</v-btn>
              </v-slide-x-transition>
          </v-flex>     
      </v-layout>
    </v-container>

</template>

<script>
import axios from "../../plugins/axios";
import { mapState, mapActions } from "vuex";

export default {
  props: {
    target: {
      type: String,
      default: ""
    }
  },
  data: () => ({
    change: false,
    small: false,
    showDialog: false
  }),
  methods: {
    store() {
      this.$store.dispatch("user/updateUser");
      this.user.formChange = false;
    },
    reset() {
      this.$store.dispatch("user/resetUser");
      this.user.formChange = false;
    }
  },
  computed: {
    ...mapState(["user", "settings", "types", "type"])
  },
  created() {
    this.$store.dispatch("user/getOrganisations");
  }
};
</script>

<style scoped>
.app_color {
  color: silver;
}
</style>


